export const IS_TH = true;
export const IS_BK = false;
export const UPDATE_APP_URL = 'th_update_app_url';
